import { useEffect, useCallback } from 'react'
import { useAppDispatch } from '../store'
import useAppState from '../hooks/useAppState'
import { setUser, setFirebaseUser, setAuthInitialized, clearAuth } from '../store/slices/authSlice'
import { resetActivities } from '../store/slices/activitiesSlice'

/**
 * ReduxAuthSync Component
 * Syncs AppStateProvider user data with Redux store
 * This ensures Redux has access to user data for middleware and other Redux-based features
 */
export const ReduxAuthSync: React.FC = () => {
  const { state } = useAppState()
  const dispatch = useAppDispatch()

  // Memoize sync logic to avoid recreating on every render
  const syncAuth = useCallback(() => {
    // Sync user data to Redux
    if (state.user && state.user.id) {
      dispatch(setUser(state.user))
      if (state.firebaseUser) {
        dispatch(setFirebaseUser(state.firebaseUser))
      }
    } else {
      // Clear Redux auth if no user
      dispatch(clearAuth())
      dispatch(resetActivities())
    }

    // Sync auth initialization status
    dispatch(setAuthInitialized(state.isAuthInitialized || false))
  }, [state.user, state.firebaseUser, state.isAuthInitialized, dispatch])

  useEffect(() => {
    syncAuth()
  }, [syncAuth])

  return null
}
